<template>
  <footer id="contato" class="rodape-wrapper">
    <hr class="mb-4" />
    <span>Links úteis</span>
    <div class="mt-2 vw-100">
      <a
        class="mr-5 text-dark"
        target="_blank"
        href="https://klausfiscal.com.br/blog/"
        >blog</a
      ><a
        class="mr-5 text-dark"
        target="_blank"
        href="https://atendimento.klausfiscal.com.br/kb"
        >ajuda</a
      ><a
        class="mr-5 text-dark"
        target="_blank"
        href="https://klausfiscal.com.br/termo-de-uso-e-politica-de-privacidade/"
        >termos de uso e privacidade</a
      >
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
.rodape-wrapper {
  margin: 10vh auto 5vh;
  width: 90vw;
}

.rodape-wrapper a:hover {
  color: #007fff !important;
}

p {
  margin: 5px 0;
}

span {
  font-weight: 600;
  font-size: 1.2rem;
}
</style>